import React, { useContext, useState } from 'react'
import { AuthContext, EventsContext, LanguageContext } from '../context'
import YouTube from "react-youtube";

const HomePage = () => {

  const { authStateLoaded, userDataLoaded, isUserAuthenticated } = useContext(AuthContext)
  const { promptCreateEvent } = useContext(EventsContext)
  const { t } = useContext(LanguageContext)
  const [loading, setLoading] = useState(false)

  const showLoading = loading || (!authStateLoaded || (isUserAuthenticated && !userDataLoaded))

  const options = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 1,
      controls: 1,
    }
  };

  const _onReady = (event) => {
    event.target.pauseVideo();
  }

  return (
    <div className='mx-4'>
      {showLoading && <div className='global-loading'>
        <div className='global-loading__background' />
        <div className='global-loading__spinner' />
      </div>}

      <h1 className='big-title mb-10 mt-20 lg:mt-32'>
        {t('home.title')}
      </h1>
      <p className='home-page-text mx-auto mb-20'>
        <b>WeCar </b>{t('home.subtitle')}
      </p>
      {/* <img src="/calendars.jpg" className='mx-auto mb-20'/> */}
      <div className='grid lg:grid-cols-3 gap-16 max-w-5xl mx-auto mb-20'>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-9 mx-auto w-36'>
            <img src='1.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.create_title')}</h3>
          <p className='home-text'>
            {t('home.create_text')}
          </p>
        </div>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-8 mx-auto w-32'>
            <img src='2.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.share_title')}</h3>
          <p className='home-text'>
            {t('home.share_text')}
          </p>
        </div>
        <div className='max-w-64 mx-auto'>
          <div className='img-parent mb-4 mx-auto w-32'>
            <img src='3.svg' className='w-full' />
          </div>
          <h3 className='home-title'>{t('home.organise_title')}</h3>
          <p className='home-text'>
            {t('home.organise_text')}
          </p>
        </div>
      </div>
      <div className='mb-10'>
        <button className='mx-auto big max-w-96 w-full' onClick={promptCreateEvent}>{t('event.create_button')}</button>
      </div>

      <div className="m-auto text-center" >
        <YouTube videoId="VTgGOQ_k7F0" options={options} onReady={_onReady} id="video" />;
      </div>

    </div>
  )
}

export default HomePage
